<template>
  <div class="NotFound">
    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card height="400" color="transparent" flat>
            <div class="display-3 primary--text">{{$t('page_not_found.title')}}</div>
            <div class="subheading secondary--text text--darken-1">{{$t('page_not_found.subtitle')}}</div>
            <div class="title py-4 primary--text">{{$t('page_not_found.support')}}</div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PageNotFound"
};
</script>
